import LogoAnimated from "components/svg/LogoAnimated";
import LogoAnimatedSurprised from "components/svg/LogoAnimatedSurprised";
import LogoAnimatedHappy from "components/svg/LogoAnimatedHappy";
import LogoAnimatedStressed from "components/svg/LogoAnimatedStressed";
import { ReactComponent as SiteName } from "assets/img/site-name.svg";
import { FrankyAnimation } from "types/FrankyAnimation";

export const FrankenstoriesLogo = (props: { type?: FrankyAnimation; hideText?: boolean; useMaxWidth?: boolean }) => {
    const { type = "Normal", hideText, useMaxWidth = true } = props;

    const LogoUrl =
        type === "Normal"
            ? LogoAnimated
            : type === "Surprised"
            ? LogoAnimatedSurprised
            : type === "Stressed"
            ? LogoAnimatedStressed
            : LogoAnimatedHappy;

    return (
        <div className="vstack align-items-center gap-1 gap-lg-0">
            <div style={{ maxWidth: useMaxWidth ? 220 : "none", width: "100%" }}>
                <LogoUrl />
            </div>

            {!hideText && (
                <div style={{ maxWidth: useMaxWidth ? 290 : "none", width: "100%", fill: "white" }}>
                    <SiteName className="img-fluid" />
                </div>
            )}
        </div>
    );
};
